import React, { useState } from 'react'
import RemoteAccessPage from './RemoteAccess'

export const RemoteAccess = props => {
	const [pageKey, setPageKey] = useState(true)
	const resetPage = () => {
		setPageKey(prev => !prev)
	}
	const isDeviceOnline = props.data.device?.deviceStatus && props.data.device?.deviceStatus !== 'offline'
	return <RemoteAccessPage key={pageKey} resetPage={resetPage} appManagerVersion={props.data.device?.appManagerVersion} isDeviceOnline={isDeviceOnline} {...props}/>
}

